<template>
  <el-menu
    :default-active="$route.path"
    class="el-menu-vertical-demo"
    @open="handleOpen"
    @close="handleClose"
    @select="menuSelect"
    :router="true"
    :collapse="isCollapse"
    style="height: 100%"
  >
    <template v-for="(item, index) in menuList">
      <el-submenu
        v-if="item.children"
        :index="item.route"
        :disabled="item.disabled"
        :key="index"
      >
        <template slot="title">
          <i v-if="item.icon" :class="item.icon"></i>
          <img v-else :src="item.img" alt="" srcset="" />
          <span>{{ $t(item.title) }}</span>
        </template>
        <template v-for="(child, idx) in item.children">
          <el-menu-item-group v-if="child.title" :key="idx">
            <template slot="title">{{ $t(child.title) }}</template>
            <el-menu-item
              style="padding-left: 0.3802rem"
              v-for="(nextChild, i) in child.children"
              :key="i"
              :index="nextChild.route"
              :disabled="nextChild.disabled"
              >{{ $t(nextChild.title) }}</el-menu-item
            >
          </el-menu-item-group>
          <el-menu-item
            v-else
            style="padding-left: 0.3802rem"
            v-for="(nextChild, i) in child.children"
            :key="i"
            :index="nextChild.route"
            :disabled="nextChild.disabled"
            >{{ $t(nextChild.title) }}</el-menu-item
          >
        </template>
        <!-- <el-submenu index="1-4">
            <template slot="title">选项4</template>
            <el-menu-item index="1-4-1">选项1</el-menu-item>
          </el-submenu> -->
      </el-submenu>
      <el-menu-item
        v-else
        :key="index"
        :index="item.route"
        :disabled="item.disabled"
      >
        <i v-if="item.icon" :class="item.icon"></i>
        <img v-else :src="item.img" alt="" srcset="" />
        <span slot="title">{{ $t(item.title) }}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>

<script>
import menuList from "../../../common/resources/menu.js";
export default {
  props: {
    isCollapse: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      list: menuList,
    };
  },
  computed: {
    menuList() {
      let menu = JSON.parse(JSON.stringify(menuList));
      let list = [];
      let that = this;
      menu.map((item) => {
        if (item.permissionCode) {
          if (that.$permission(item.permissionCode, false)) {
            list.push(item);
          }
        } else {
          if (item.children && item.children.length > 0) {
            console.log(item);
            let childrenList = item;
            let children = [];
            item.children.map((ele) => {
              let childList = [];
              ele.children.map((child) => {
                if (child.permissionCode) {
                  that.$permission(child.permissionCode, false) &&
                    childList.push(child);
                } else {
                  childList.push(child);
                }
              });
              childList.length > 0 && children.push({ children: childList });
            });

            childrenList.children = children;
            children.length > 0 && list.push(childrenList);
          } else {
            list.push(item);
          }
        }
      });
      return list;
    },
  },
  methods: {
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    menuSelect(e) {},
  },
};
</script>

<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
</style>